// Improved MobileNavigation class (ES6+, a11y-minded)
class MobileNavigation {
    constructor() {
        this.$toggle = $('#menu-toggle');
        this.$wrapper = $('#mobnav-wrapper');
        this.$body = $('body');

        this.setVhUnit = this.setVhUnit.bind(this);

        this.setVhUnit();
        window.addEventListener('resize', this.setVhUnit);

        this.$toggle.on('click', (e) => {
            e.preventDefault();
            this.$toggle.hasClass('hamburger-open') ? this.closeNav() : this.openNav();
        });

        $(document).on('click', '.mob-nav__primary__link-open', (e) => this.onPrimaryToggleClick(e));

        $(document).on('click', '.primary__close', (e) => {
            e.preventDefault();
            this.closeAllSubnavs();
        });

        $(document).on('click', '.close-mobile-nav', (e) => {
            e.preventDefault();
            this.closeNav();
        });

        // ✅ Close on anchor / normal navigation clicks INSIDE the mobile nav
        // - closes on same-page anchors (#...)
        // - also closes on normal page navigation ("/seite")
        // - ignores "open subnav" buttons (handled above)
        $(document).on('click', '#mobnav-wrapper a', (e) => this.onNavLinkClick(e));

        $(document).on('keydown', (e) => {
            if (e.key === 'Escape' && this.$body.hasClass('mobile-nav-open')) this.closeNav();
        });

        //$(window).on('resize', () => this.closeNav());

        $(document).on('focusin', '.img-infobtn, .t-bc, .htmleditor a, .footer a', () => {
            if (this.$body.hasClass('mobile-nav-open')) this.closeNav();
        });
    }

    setVhUnit() {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    openNav() {
        this.$toggle.attr('aria-expanded', 'true').addClass('hamburger-open');
        this.$wrapper.addClass('open');
        this.$body.addClass('mobile-nav-open');

        const $first = this.$wrapper
            .find('a,button,[tabindex]:not([tabindex="-1"])')
            .filter(':visible')
            .first();
        if ($first.length) $first.focus();
    }

    closeNav() {
        this.$wrapper.removeClass('open');
        this.$toggle.attr('aria-expanded', 'false').removeClass('hamburger-open');
        this.$body.removeClass('mobile-nav-open');
        this.closeAllSubnavs();
        this.$toggle.focus();
    }

    /* ---------- NEW: link click handler ---------- */

    onNavLinkClick(e) {
        // only if nav is open
        if (!this.$body.hasClass('mobile-nav-open')) return;

        const $a = $(e.currentTarget);

        // ignore "open subnav" links/buttons (handled by onPrimaryToggleClick)
        if ($a.is('.mob-nav__primary__link-open')) return;

        const href = ($a.attr('href') || '').trim();
        if (!href || href === '#') return;

        const isSamePageAnchor = href.startsWith('#');
        const isJsLink = href.toLowerCase().startsWith('javascript:');
        const isMailOrTel = href.startsWith('mailto:') || href.startsWith('tel:');

        if (isJsLink) return;

        // For same-page anchors: let the browser scroll, then close
        if (isSamePageAnchor) {
            // (Optional) if you do custom smooth scroll elsewhere and preventDefault there,
            // you'll still close the nav because we don't preventDefault here.
       //     requestAnimationFrame(() => this.closeNav());
        //    return;
        }

        // For normal navigation (including mailto/tel): close immediately
        // (If it's a real page navigation, the page will unload anyway, but this feels snappier)
        this.closeNav();
    }

    /* ---------- subnav ---------- */

    onPrimaryToggleClick(e) {
        e.preventDefault();
        const $btn = $(e.currentTarget);
        this.toggleSubnav($btn, {closeSiblings: true});
    }

    toggleSubnav($btn, {closeSiblings = true} = {}) {
        const expanded = $btn.attr('aria-expanded') === 'true';
        const newState = !expanded;

        $btn.attr('aria-expanded', newState.toString()).toggleClass('is-open', newState);

        const panelId = $btn.attr('aria-controls');
        const $panel = panelId ? $('#' + panelId) : $();

        $('.mob-nav__primary__link').removeClass('current');

        if (newState) {
            if (closeSiblings) this.closeSiblingSubnavs($btn);
            $btn.parent().addClass('open');
            this.openPanel($panel);
        } else {
            $btn.parent().removeClass('open');
            this.closePanel($panel);
        }
    }

    openPanel($panel) {
        if (!$panel || !$panel.length) return;
        $panel.removeAttr('hidden').addClass('is-visible');

        const $first = $panel
            .find('a,button,[tabindex]:not([tabindex="-1"])')
            .filter(':visible')
            .first();
        if ($first.length) $first.focus();
    }

    closePanel($panel) {
        if (!$panel || !$panel.length) return;
        $panel.attr('hidden', '').removeClass('is-visible');
    }

    closeSiblingSubnavs($btn) {
        const $siblings = $('.mob-nav__primary__link-open').not($btn);

        $siblings.each((_, el) => {
            const $other = $(el);

            if ($other.attr('aria-expanded') === 'true') {
                $other.attr('aria-expanded', 'false').removeClass('is-open');

                // ✅ WICHTIG: Parent-Open wegnehmen
                $other.parent().removeClass('open');
                $other.removeClass('current');
                $other.removeClass('section');

                const pid = $other.attr('aria-controls');
                if (pid) this.closePanel($('#' + pid));
            }
        });
    }

    closeAllSubnavs() {
        const $all = $('.mob-nav__primary__link-open');
        $all.attr('aria-expanded', 'false').removeClass('is-open');
        $all.each((_, el) => {
            const pid = $(el).attr('aria-controls');
            if (pid) this.closePanel($('#' + pid));
        });
    }
}